var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"id":"viewTemplateModal","size":"lg","type":"fullheight","modalBodyClass":"overflow-hidden p-2","toggle":true}},[_c('iframe',{staticClass:"template-frame",attrs:{"title":"static mail template","srcdoc":_vm.templateHtml,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }